import axios from "axios";
import { axiosPrivate } from "../serviceFile/api/interceptor.jsx";

// const BASE_URL = process.env.REACT_APP_API_URL;

const originValue = window.location.origin;
let BASE_URL = null;
if (originValue === "http://192.168.1.45:8888") {
  BASE_URL = "http://192.168.1.45:8888/api/";
} else if (originValue === "http://117.193.164.101:8888") {
  BASE_URL = process.env.REACT_APP_API_URL;
} else {
  BASE_URL = null;
}

console.log(originValue, "origin");
console.log(BASE_URL, "baseURL");

// Vendor details api

export const loginApi = (body) => {
  return axios.post(BASE_URL + "token/", body);
};

export const vendorDetails = () => {
  const vendorCode = localStorage.getItem("vendor_code");
  return axiosPrivate.get(BASE_URL + "vendor/" + vendorCode);
};

export const poDetails = (poNumber) => {
  return axiosPrivate.get(BASE_URL + "po/" + poNumber);
};

export const vendorRegistration = (Vcode) => {
  const body = {
    vendor_code: Vcode,
  };
  return axios.post(BASE_URL + "confirm/vendor", body);
};

// 4500000700

export const otpVerification = (otp, Vcode) => {
  const data = {
    otp: otp,
    vendor_code: Vcode,
  };
  return axios.post(`${BASE_URL}confirm/otp`, data);
};

export const resetPassword = (body) => {
  const token = localStorage.getItem("token");
  const config = {
    headers: {
      Authorization: "Token " + token,
    },
  };
  return axios.post(BASE_URL + "register/vendor", body, config);
};

export const changePassword = (body) => {
  return axiosPrivate.post(BASE_URL + "vendor/change/password", body);
};

export const forgetPasswordVendorCode = (Vcode) => {
  const body = {
    vendor_code: Vcode,
  };
  return axios.post(BASE_URL + "forgot/password/confirm/vendor", body);
};

export const forgotPasswordOtpVerification = (otp, Vcode) => {
  const data = {
    otp: otp,
    vendor_code: Vcode,
  };

  return axios.post(`${BASE_URL}forgot/password/confirm/otp`, data);
};

export const forgotPasswordreset = (body) => {
  const token = localStorage.getItem("token");
  const config = {
    headers: {
      Authorization: "Token " + token,
    },
  };
  return axios.post(BASE_URL + "forgot/password/reset", body, config);
};
